import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeft, ChevronRight, BookOpen } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/ts6dRYUZzfZwUhQDbVB9f9/FE18F22A-1C4B-475F-9A43-BDF3113CA0E9.webp',
  caption: 'Banco de Ejercicios — Clase 1: ¿Qué es Programar?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vAg7eDVazeBBA8rRvtFzhe/35B00340-7C1E-4439-A51B-E1C56914FA33.webp',
  caption: '1.1 — ¿Qué es HTML? — Explicación visual lista'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3rootg8KJEdtSW4YR4t2oE/75A4B452-45BD-4A4E-828C-283785775743.webp',
  caption: 'Configuración de VS Code + Funciones en Python'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dgQoscY94LYKGaNgdU9si9/256F0E59-14E0-42C4-882B-4805050ACA4E.webp',
  caption: 'Bienvenido a Python — Marco teórico para el aula'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sp3aFsRUNDpGMPYfiErq2c/9CF9295E-FC3B-451B-9971-957D30E33A69.webp',
  caption: 'Ciclos MIENTRAS / PARA / REPETIR — Sintaxis y ejemplos'
}];
export function PreviewCarousel() {
  const [index, setIndex] = useState(0);
  const next = () => setIndex(i => (i + 1) % images.length);
  const prev = () => setIndex(i => (i - 1 + images.length) % images.length);
  useEffect(() => {
    const t = setInterval(next, 4500);
    return () => clearInterval(t);
  }, []);
  return <section className="py-6 md:py-12 px-3 bg-brand-card border-t border-white/5" data-id="element-183">
      <div className="max-w-3xl mx-auto" data-id="element-184">
        <div className="text-center mb-5" data-id="element-185">
          <div className="inline-flex items-center gap-2 bg-brand-accent/20 text-brand-accent font-black px-3 py-1.5 rounded-full mb-3 border border-brand-accent/50 text-[10px] md:text-xs tracking-widest uppercase" data-id="element-186">
            <BookOpen className="w-3.5 h-3.5" data-id="element-187" />
            VISTA POR DENTRO
          </div>
          <h2 className="text-xl md:text-3xl font-black text-white mb-2" data-id="element-188">
            🔍 Mirá el Kit por dentro
          </h2>
          <p className="text-xs md:text-sm text-gray-400 font-medium max-w-xl mx-auto" data-id="element-189">
            Páginas reales del material que vas a recibir. Diseño claro, tablas
            listas, ejemplos del laboratorio y consignas listas para imprimir.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative rounded-xl overflow-hidden border-2 border-brand-accent/30 bg-brand-dark shadow-[0_0_25px_rgba(34,197,94,0.15)] cursor-pointer" onClick={scrollToCompra} data-id="element-190">
          {/* Slide */}
          <div className="relative aspect-[4/5] md:aspect-[16/10] w-full bg-brand-dark" data-id="element-191">
            {images.map((img, i) => <img key={i} src={img.src} alt={img.caption} className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ease-in-out ${i === index ? 'opacity-100' : 'opacity-0'}`} loading={i === 0 ? 'eager' : 'lazy'} data-id="element-192" />)}
          </div>

          {/* Prev / Next */}
          <button onClick={e => {
          e.stopPropagation();
          prev();
        }} aria-label="Anterior" className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 bg-brand-accent hover:bg-brand-accentDark text-white rounded-full p-2 md:p-2.5 shadow-lg transition-colors" data-id="element-193">
            <ChevronLeft className="w-4 h-4 md:w-5 md:h-5" data-id="element-194" />
          </button>
          <button onClick={e => {
          e.stopPropagation();
          next();
        }} aria-label="Siguiente" className="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 bg-brand-accent hover:bg-brand-accentDark text-white rounded-full p-2 md:p-2.5 shadow-lg transition-colors" data-id="element-195">
            <ChevronRight className="w-4 h-4 md:w-5 md:h-5" data-id="element-196" />
          </button>

          {/* Caption */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-3 md:p-4 pt-8" data-id="element-197">
            <p className="text-white font-bold text-xs md:text-sm text-center" data-id="element-198">
              {images[index].caption}
            </p>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-1.5 mt-3" data-id="element-199">
          {images.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir a slide ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === index ? 'bg-brand-accent w-6' : 'bg-white/20 w-1.5'}`} data-id="element-200" />)}
        </div>

        <p className="text-center text-[10px] md:text-xs text-gray-500 mt-3 font-medium" data-id="element-201">
          📄 {index + 1} de {images.length} · Toca la imagen para ir a la oferta
        </p>
      </div>
    </section>;
}